import { Component, OnInit,OnDestroy } from '@angular/core';
import { UntypedFormBuilder,UntypedFormGroup,FormControl } from '@angular/forms';
import {ExamsService} from '../exams.service';
import {AutotextService} from '../autotext.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'app-ovaries',
    templateUrl: './ovaries.component.html',
    styleUrls: ['./ovaries.component.scss'],
    standalone: false
})
export class OvariesComponent implements OnInit,OnDestroy {

  AdnexaForm: UntypedFormGroup;
  lnormal: string = "Normal";
  rnormal: string = "Normal";
  formSub:Subscription;
  mediaSub: Subscription;

  constructor(public atS: AutotextService, public es: ExamsService,private fb:UntypedFormBuilder) {
    this.AdnexaForm = this.fb.group({
      LObserved: [''],
      LSizeX: [''],
      LSizeY:  [''],
      LSizeZ:  [''],
      LPI:  [''],
      LPIStatus:  [''],
      LRI:  [''],
      LRIStatus:  [''],
      LSD:[''],
      LSDStatus:[''],
      RObserved:  [''],
      RSizeX:  [''],
      RSizeY:  [''],
      RSizeZ:  [''],
      RPI:  [''],
      RPIStatus:  [''],
      RRI: [''],
      RRIStatus: [''],
      RSD: [''],
      RSDStatus: [''],
      Fluid:[''],
      POD:[''],
      Comments:[''],
      LComments:[''],
      RComments:[''],
      DiagnosisCodes: [''],
      Diagnosis: ['']
    });
   }

  ngOnInit() {
    this.es.fillForm(this.AdnexaForm,"adnexa",false,true);
    this.formSub = this.es.formLoaded$.subscribe(()=>{
      this.lnormal = this.AdnexaForm.get('LObserved').value;
      this.rnormal = this.AdnexaForm.get('RObserved').value;
    });
    this.es.getSRs();
    if(!this.es.isClosed)
      this.mediaSub =  this.es.mediaArrived$.subscribe((mediatype)=>{
        if(mediatype == 'html')
          this.es.fillForm(this.AdnexaForm,"adnexa",false,true);
      });
  }

  ngOnDestroy(){
    this.formSub.unsubscribe();
    if(this.mediaSub)
      this.mediaSub.unsubscribe();
  }

  volume(side:string):number{
    let sd = 'L';
    if(side == 'r')
      sd = 'R';
    if(this.AdnexaForm.get(sd+'SizeX').value && this.AdnexaForm.get(sd+'SizeY').value && this.AdnexaForm.get(sd+'SizeZ').value)
    //the simplified formula 0.5 × length × width × thickness is used
      return (0.5 * this.AdnexaForm.get(sd+'SizeX').value * this.AdnexaForm.get(sd+'SizeY').value* this.AdnexaForm.get(sd+'SizeZ').value) / 1000;
    return null;
  }

  setN(side:string, val:string){
    this.AdnexaForm.get(side + "Observed").setValue(val);
  }

  reset(item:string){
    if(! this.es.isClosed){
      this.AdnexaForm.get(item).setValue(-1);
    }
  }



}
